import script from "./CondolenceFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CondolenceFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./CondolenceFormDialog.vue?vue&type=style&index=0&id=0c5921da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5921da"]])

export default __exports__